<template>
  <div class="md-layout md-alignment-top-center">
    <div class="md-layout-item md-size-60 md-small-size-100">

      <md-card>

        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>edit</md-icon>
          </div>

          <div>
            <h4 class="title">Edit Utilization Sheet</h4>
            <p class="category">
              Update utilization sheet information
            </p>
          </div>
        </md-card-header>

        <form @submit.prevent="update">

          <md-card-content>

            <!-- Vendor & Department -->
            <div class="md-layout">

              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="field-label">
                  Vendor
                </label>

                <v-select
                    :key="'vendor-' + vendors.length"
                    :value="invoice.vendor_id"
                    :options="vendors"
                    label="name"
                    :reduce="item => String(item.id)"
                    placeholder="Select Vendor"
                    clearable
                    @input="onVendorChange"
                />

                <validation-error
                    :errors="apiValidationErrors.vendor_id"
                />

              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="field-label">
                  Department
                </label>

                <v-select
                    :key="'department-' + invoice.vendor_id + '-' + departments.length"
                    :value="invoice.department_id"
                    :options="departments"
                    label="name"
                    :reduce="item => String(item.id)"
                    placeholder="Select Department"
                    clearable
                    @input="value => invoice.department_id = value"
                />

                <validation-error
                    :errors="apiValidationErrors.department_id"
                />

              </div>

            </div>

            <!-- Guidance Type -->
            <div class="md-layout mt-20">
              <div class="md-layout-item md-size-50 md-small-size-100">
              <label class="field-label">
                Guidance Type
              </label>

              <div class="radio-group">

                <md-radio
                    v-model="invoice.guidance_type"
                    value="Per Man Hour"
                >
                  Per Man Hour
                </md-radio>

                <md-radio
                    v-model="invoice.guidance_type"
                    value="Per Work Done"
                >
                  Per Work Done
                </md-radio>

              </div>

              <validation-error
                  :errors="apiValidationErrors.guidance_type"
              />
              </div>
              <!-- Pay code -->
              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="field-label">
                  Pay Code
                </label>

                <div class="radio-group" v-if="invoice.guidance_type==='Per Work Done'">

                  <md-radio
                      v-model="invoice.pay_code"
                      value="PT"
                  >
                    Per Tonnage (PT)
                  </md-radio>

                  <md-radio
                      v-model="invoice.pay_code"
                      value="PU"
                  >
                    Per Unit (PU)
                  </md-radio>
                  <md-radio
                      v-model="invoice.pay_code"
                      value="TU"
                  >
                    Per TEUs (TU)
                  </md-radio>

                </div>
                <div class="radio-group" v-if="invoice.guidance_type==='Per Man Hour'">

                  <md-radio
                      v-model="invoice.pay_code"
                      value="MH"
                  >
                    Man Hour (MH)
                  </md-radio>

                </div>

                <validation-error
                    :errors="apiValidationErrors.pay_code"
                />

              </div>
              <!-- Time Clock Status -->
              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="field-label">
                  Time Clock Status
                </label>

                <v-select
                    v-model="invoice.time_clock_status"
                    :options="timeClockStatuses"
                    label="name"
                    :reduce="item => item.id"
                    placeholder="Select Time Clock Status"
                    clearable
                />

                <validation-error
                    :errors="apiValidationErrors.time_clock_status"
                />

              </div>

            </div>

            <!-- Date Range -->
            <div class="md-layout mt-20">

              <div class="md-layout-item md-size-50 md-small-size-100">

                <md-datepicker
                    v-model="invoice.start_date"
                    :md-disabled-dates="disabledDates"
                    :md-model-type="String"
                    md-immediately
                >
                  <label>Start Date</label>
                </md-datepicker>

                <validation-error
                    :errors="apiValidationErrors.start_date"
                />

              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">

                <md-datepicker
                    v-model="invoice.end_date"
                    :md-disabled-dates="disabledDates"
                    :md-model-type="String"
                    md-immediately
                >
                  <label>End Date</label>
                </md-datepicker>

                <validation-error
                    :errors="apiValidationErrors.end_date"
                />

              </div>

            </div>

            <!-- Summary -->
            <div class="summary-box">

              <div>
                <strong>Vendor:</strong>
                {{ selectedVendor }}
              </div>

              <div>
                <strong>Department:</strong>
                {{ selectedDepartment }}
              </div>

              <div>
                <strong>Guidance Type:</strong>
                {{ invoice.guidance_type || '-' }}
                ({{ invoice.pay_code || '-' }})
              </div>
              <div>
                <strong>Time Clock Status:</strong>
                {{ invoice.time_clock_status || '-' }}
              </div>

            </div>

          </md-card-content>

          <md-card-actions>

            <md-button
                class="md-simple"
                @click="goBack"
            >
              Cancel
            </md-button>

            <md-button
                type="submit"
                class="md-success"
                :disabled="isLoading || !formReady"
            >
              {{ isLoading ? 'Updating...' : 'Update Utilization Sheet' }}
            </md-button>

          </md-card-actions>

        </form>
        <md-progress-bar
            v-if="!formReady"
            md-mode="indeterminate"
        />
      </md-card>

    </div>
  </div>
</template>

<script>
import { ValidationError } from '@/components'
import formMixin from '@/mixins/form-mixin'
import Vuex from "vuex";

export default {
  components: {
    ValidationError
  },

  mixins: [formMixin],

  data: () => ({
    loadingInvoice: true,
    loadingVendors: true,
    loadingDepartments: true,
    isLoading: false,
    timeClockStatuses: [
      {
        id: 'Assigned',
        name: 'Assigned'
      },
      {
        id: 'Supervisor_Checked_In',
        name: 'Supervisor Checked In'
      },
      {
        id: 'Checked_Out',
        name: 'Checked Out'
      },
      {
        id: 'Supervisor_Checked_Out',
        name: 'Supervisor Checked Out'
      }
    ],
    invoice: {
      type: 'invoices',
      id:null,
      vendor_id: null,
      department_id: null,
      guidance_type: 'Per Man Hour',
      pay_code: null,
      payment_mode: null,
      start_date: null,
      end_date: null,
      time_clock_status: null
    },
    user_station: {},

    vendors: [],
    departments: [],

    disabledDates: date => {
      return date > new Date().setHours(0, 0, 0, 0)
    }
  }),
  async created () {
    await this.initialize()
  },

  // async created () {
  //   await this.getVendors()
  //   await this.get()
  //   this.loadingInvoice = false
  // },

   watch: {
     me: {
       handler: function (val) {
         if (val != null) {
           this.user_station = val.model.department.station;
           this.getVendors();
         }
       },
       deep: true,
       immediate: true,
     },
     'invoice.guidance_type'(value) {
       if (value === 'Per Man Hour') {
         // Man Hour must always use MH
         this.invoice.pay_code = 'MH';
       } else if (value === 'Per Work Done') {
         // Default to PT when switching to Work Done
         this.invoice.pay_code = 'PT';
       } else {
         this.invoice.pay_code = null;
       }
     }
   },

  computed: {
    ...Vuex.mapState({
      me: state => state.profile.me
    }),
    formReady () {
      return (
          !this.loadingInvoice &&
          !this.loadingVendors &&
          !this.loadingDepartments &&
          this.invoice.vendor_id &&
          this.invoice.department_id &&
          this.invoice.start_date &&
          this.invoice.end_date &&
          this.invoice.guidance_type &&
          this.invoice.time_clock_status
      )
    },

    selectedVendor () {
      const item = this.vendors.find(
          v => String(v.id) === String(this.invoice.vendor_id)
      )

      return item ? item.name : '-'
    },

    selectedDepartment () {
      const item = this.departments.find(
          d => String(d.id) === String(this.invoice.department_id)
      )

      return item ? item.name : '-'
    }

  },

  methods: {
    async onVendorChange (vendorId) {

      this.invoice.vendor_id = vendorId

      this.invoice.department_id = null

      if (vendorId) {
        await this.getDepartments(vendorId)
      } else {
        this.departments = []
      }
    },
    async initialize () {
      try {
        this.loadingInvoice = true

        await this.getVendors()

        const id = this.$route.params.id

        await this.$store.dispatch('invoices/get',
            {
              id: this.$route.params.id,
              include: 'vendor,department'
            });

        const invoice =
            this.$store.getters['invoices/invoice']

        this.invoice = {
          ...invoice,
          vendor_id: invoice.vendor
              ? String(invoice.vendor.id)
              : null,
          department_id: invoice.department
              ? String(invoice.department.id)
              : null
        }

        if (this.invoice.vendor_id) {
          await this.getDepartments(
              this.invoice.vendor_id
          )
        }

      } catch (e) {

        await this.$store.dispatch(
            'alerts/alert',
            e.response
        )

      } finally {

        this.loadingInvoice = false
      }
    },

    async get () {
      this.loadingInvoice = true

      try {

        await this.$store.dispatch('invoices/get',
            {
              id: this.$route.params.id,
              include: 'department,vendor'
            });

        this.invoice =
            this.$store.getters['invoices/invoice']

        this.invoice.vendor_id =
            this.invoice.vendor?.id || null

        this.invoice.department_id =
            this.invoice.department?.id || null

        if (this.invoice.vendor_id) {
          await this.getDepartments(
              this.invoice.vendor_id
          )
        }
      }catch (e){
        await this.$store.dispatch(
            'alerts/alert',
            e.response
        )
      } finally {
        this.loadingInvoice = false
      }
    },

    async getVendors () {

      this.loadingVendors = true

      try {
        let vendorParams = { filter: { 'station': '' } };
        let station = this.user_station ? this.user_station : null;
        if (typeof station !== 'undefined' && station != null) {
          vendorParams.filter.station = station.id;
        } else {
          vendorParams = null;
        }

        await this.$store.dispatch('vendors/list',vendorParams)

        this.vendors =
            this.$store.getters['vendors/dropdown']
                .map(item => ({
                  ...item,
                  id: String(item.id)
                }))

      } finally {

        this.loadingVendors = false
      }
    },
    async getDepartments (vendorId = null) {

      this.loadingDepartments = true

      try {

        const params = {
          filter: {
            ...(vendorId
                ? { vendor: vendorId }
                : {}),
            ...(this.user_station
            ?{station:this.user_station.id}
            :{})
          }
        }


        await this.$store.dispatch(
            'departments/list',
            params
        )

        this.departments =
            this.$store.getters['departments/dropdown']
                .map(item => ({
                  ...item,
                  id: String(item.id)
                }))

      } finally {

        this.loadingDepartments = false
      }
    },

    async update () {

     // const payload = { ...this.invoice };
      const payload = {
        ...this.invoice,
        vendor: {
          id: this.invoice.vendor_id,
          type: 'vendors'
        },

        department: {
          id: this.invoice.department_id,
          type: 'departments'
        }
      }

      delete payload.voucher;
      delete payload.invoiceItems;

      try {
        await this.$store.dispatch('invoices/update', payload);

        await this.$store.dispatch(
            'alerts/success',
            'Utilization Sheet updated successfully.'
        );

        this.goBack();

      } catch (e) {
        await this.$store.dispatch('alerts/alert', e.response);
        this.setApiValidation(e.response.data.errors);
      }
    },

    goBack () {
      this.$router.push({
        name: 'Utilization Sheet List'
      })
    }
  }
}
</script>

<style scoped>

.field-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
}

.mt-20 {
  margin-top: 20px;
}

.radio-group {
  display: flex;
  gap: 25px;
  align-items: center;
}

.summary-box {
  margin-top: 20px;
  padding: 12px 15px;
  border-radius: 6px;
  background: #f7f7f7;
  border-left: 4px solid #4caf50;
}

.summary-box div {
  margin-bottom: 4px;
}

.summary-box div:last-child {
  margin-bottom: 0;
}

</style>
